import { Box } from "@mui/material";
import ReBox from "../../../../common/ReBox/ReBox";
import HeaderBox from "../HeaderBox/HeaderBox";
import { useContext } from "react";
import { GlobalContext } from "../../../../common/Context";
import { hexToRGBA } from "../../../../common/Utils/Utils";
import { white } from "../../../../../theme/colours";

const CardBase = (props) => {
  const {
    children,
    redirect,
    title,
    boxStyle,
    areaStyle,
    headerColor,
    subTitle,
  } = props;
  const { mobileView } = useContext(GlobalContext);

  const mainBoxStyle = {
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    p: 0,
    mb: mobileView && "1rem",
    background: hexToRGBA(white, 0.5),
    ...boxStyle,
  };

  return (
    <ReBox style={mainBoxStyle}>
      <HeaderBox
        title={title}
        redirect={redirect}
        bgColor={headerColor}
        subTitle={subTitle}
      />
      <Box sx={areaStyle}>{children}</Box>
    </ReBox>
  );
};

export default CardBase;
